var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import rpc from '../../api/rpc';
import store from '../../store';
import deepmerge from 'deepmerge';
import { fromPgToLocalSorting } from 'src/types';
import { set, orderBy } from 'lodash';
import { vuexActionExists } from '..';
import ensureArray from '../arrayOperations/ensureArray';
import Notify from 'quasar/src/plugins/Notify.js';;
const mergeParamsAndPayload = (getters, params, operation) => {
    const passedParams = params || {};
    const passedPaylod = passedParams.payload || passedParams;
    const moduleDefaultParams = (getters.controllerDefaultParams || {})[operation] || {};
    const moduleDefaultPayload = (moduleDefaultParams === null || moduleDefaultParams === void 0 ? void 0 : moduleDefaultParams.payload) || moduleDefaultParams;
    const defaultParamsForAllModules = (getters.controllerDefaultParamsCommonForAllModules || {})[operation] || {};
    const defaultPayloadForAllModules = (defaultParamsForAllModules === null || defaultParamsForAllModules === void 0 ? void 0 : defaultParamsForAllModules.payload) || defaultParamsForAllModules;
    const mergedParams = deepmerge(deepmerge(defaultParamsForAllModules, moduleDefaultParams), passedParams);
    const mergedPayload = deepmerge(deepmerge(defaultPayloadForAllModules, moduleDefaultPayload), passedPaylod);
    return { mergedParams, mergedPayload };
};
export default function vuexTableCommonActionsMaker() {
    return {
        fetch({ commit, getters, state, dispatch }, params) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                if (!params || !params.justReturnDataDontWriteToState) { // because if we don't exclude this then which component this params belongs will mix up
                    commit('SET_LAST_FETCH_PARAMS', params);
                }
                const { mergedParams, mergedPayload } = mergeParamsAndPayload(getters, params, 'fetch');
                if ((mergedPayload === null || mergedPayload === void 0 ? void 0 : mergedPayload.action) !== 'select') {
                    throw new Error('fetch() cannot be used with action other than `select`.  Use rpc() directly instead');
                }
                if (!(mergedPayload === null || mergedPayload === void 0 ? void 0 : mergedPayload.need_only_columns) && getters.columns && !getters.fetchAllColumnsWhenFetching && !mergedParams.fetchAllColumnsWhenFetching) {
                    set(mergedPayload, 'need_only_columns', getters.columns.map((col) => col.field || col.name));
                }
                // convert any functions into values. e.g., we may be passing function filter conditions like [{ field: user_id, predicate: 'equals', value: () => getActingUser().id }].  If we don't do the step below, then payload will be sent either with function or empty
                // tbd. now it only converts filter_condition.value
                if (mergedPayload.filter_conditions) {
                    for (const fc of mergedPayload.filter_conditions) {
                        if (typeof fc.value === 'function') {
                            // @ts-ignore
                            fc.value = fc.value();
                        }
                    }
                }
                const response = yield rpc(getters.controllers.fetch, mergedPayload);
                const prependData = getters.prependToFetchedRecords || [];
                const appendData = getters.appendToFetchedRecords || [];
                if (response) {
                    let data = [];
                    if (Array.isArray(response.data)) {
                        data = response.data;
                    }
                    else if (Array.isArray(response)) {
                        data = response;
                    }
                    else {
                        data = [];
                    }
                    if (mergedParams.applySortingModelLocally) {
                        const fields = (_a = mergedPayload.sorting_model) === null || _a === void 0 ? void 0 : _a.map(r => r.field);
                        const directions = (_b = mergedPayload.sorting_model) === null || _b === void 0 ? void 0 : _b.map(r => fromPgToLocalSorting(r.direction));
                        data = orderBy(data, fields, directions);
                    }
                    if (mergedParams.applyToEachRow !== undefined) {
                        const applyToEachRow = mergedParams.applyToEachRow;
                        data.forEach(applyToEachRow);
                    }
                    if (mergedParams.justReturnDataDontWriteToState)
                        return response; /* stops further processing */
                    // if (response.totals) commit('SET_GRAND_TOTALS_ROW', response.totals)
                    const oldData = state === null || state === void 0 ? void 0 : state.list;
                    let oldDataToKeep;
                    if (mergedParams.dontOverwriteAlreadyFetchedButAppend || mergedParams.dontOverwriteAlreadyFetchedButPrepend) {
                        oldDataToKeep = oldData;
                    }
                    else {
                        // @ts-ignore
                        oldDataToKeep = oldData.filter(row => row.onceFetchedDontAllowOverwriteByOtherFetch === true);
                    }
                    if (mergedParams.onceFetchedDontAllowOverwriteByOtherFetch) {
                        // @ts-ignore
                        data.forEach((row) => { row['onceFetchedDontAllowOverwriteByOtherFetch'] = true; });
                    }
                    let combinedData = [];
                    if (mergedParams.dontOverwriteAlreadyFetchedButAppend) {
                        combinedData = [...prependData, ...oldDataToKeep, ...data, ...appendData];
                    }
                    else if (mergedParams.dontOverwriteAlreadyFetchedButPrepend) {
                        combinedData = [...prependData, ...data, ...oldDataToKeep, ...appendData];
                    }
                    else { // repeating above for clarity
                        combinedData = [...prependData, ...data, ...oldDataToKeep, ...appendData];
                    }
                    if (mergedParams.onceFetchedApplyAsPartialRefresh) {
                        dispatch('processPartialRefresh', data);
                    }
                    else {
                        commit('SET_LIST', combinedData);
                        if (mergedParams.saveAlsoAsFullTable)
                            commit('SET_FULL_TABLE', [...combinedData]);
                    }
                    if (response.meta && response.meta.pagination && !mergedParams.onceFetchedApplyAsPartialRefresh) {
                        commit('SET_PAGINATION', response.meta.pagination);
                    }
                    if (mergedParams && mergedParams.executeAfterFetchFunc)
                        mergedParams.executeAfterFetchFunc(mergedParams);
                    // @ts-ignore
                    if (Object.keys(store._actions).includes(state._namespace + 'executeAfterFetchFunc'))
                        dispatch('executeAfterFetchFunc', mergedParams);
                    return response;
                }
                else {
                    const defaultData = [...prependData, ...appendData];
                    commit('SET_LIST', defaultData);
                    return defaultData;
                }
            });
        },
        repeatLastFetch({ dispatch, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield dispatch('fetch', state.lastFetchParams);
                return response;
            });
        },
        create({ commit, state, getters, dispatch }, params) {
            return __awaiter(this, void 0, void 0, function* () {
                params = deepmerge(deepmerge((getters.controllerDefaultParams || {}).create || {}, (getters.controllerDefaultParamsCommonForAllModules || {}).create || {}), params || {});
                const response = yield rpc(getters.controllers.create, params);
                if (response) {
                    if (response.result === 'error') {
                        debugger;
                        return response;
                    }
                    let list = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.list));
                    const fullList = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.fullTable));
                    const createdRecords = response.data || response || [];
                    if (!Array.isArray(createdRecords)) {
                        const error = 'Response from create() should be an array of created records.  Instead, it is: ' + JSON.stringify(response);
                        console.error(error);
                        Notify.create({ type: 'warning', classes: 'max-width-50rem', message: 'New record was likely created. But a confirmation could not be obtained. Please refresh the list of records to verify that the record was indeed created. For few entities, e.g., notably for Organizations, that have special access control rules, new records may take up to a minute to become available in the UI.' });
                    }
                    else {
                        createdRecords.forEach((row) => {
                            const idx = list.findIndex((r) => { var _a, _b; return r.id !== null && (row.id !== null && String((_a = r) === null || _a === void 0 ? void 0 : _a.id) === String((_b = row) === null || _b === void 0 ? void 0 : _b.id)); });
                            if (idx > -1) {
                                list[idx] = row;
                            }
                            else {
                                if (list) {
                                    if (params.insertNewRecordAtPosition) {
                                        list.splice(params.insertNewRecordAtPosition, 0, row);
                                    }
                                    else if (params.insertNewRecordAtTheEnd) {
                                        list.push(row);
                                    }
                                    else {
                                        list.unshift(row);
                                    }
                                }
                                else {
                                    list = createdRecords;
                                }
                            }
                        });
                    }
                    // in some cases, e.g., preferences.user_preferences, inserts are routed to update.  In such cases, we need to remove the old record and insert the new one
                    if (!Array.isArray(createdRecords)) {
                        debugger;
                    }
                    const fullList2 = fullList.filter(r => !createdRecords.map(cr => cr.id).includes(r.id));
                    const fullListToSet = [...fullList2, ...createdRecords];
                    commit('SET_LIST', list);
                    commit('SET_FULL_TABLE', fullListToSet);
                    const createParamsWithReponse = Object.assign(Object.assign({}, params), { response });
                    if (params && params.executeAfterCreateFunc)
                        params.executeAfterCreateFunc(createParamsWithReponse);
                    // @ts-ignore
                    if (Object.keys(store._actions).includes(state._namespace + 'executeAfterCreateFunc'))
                        dispatch('executeAfterCreateFunc', createParamsWithReponse);
                    return response;
                }
            });
        },
        update({ state, getters, dispatch }, params) {
            return __awaiter(this, void 0, void 0, function* () {
                if (params.whoInitiatedThis !== 'updateRecords') {
                    console.error('This function should only be initiated by updateRecords() entity operation.  Do not call it directly.  This is done for code readability and TS tooling');
                    debugger;
                }
                // eslint-disable-next-line no-unused-vars
                const { mergedPayload } = mergeParamsAndPayload(getters, params, 'update');
                const response = yield rpc(getters.controllers.update, mergedPayload);
                if (response) {
                    dispatch('processPartialRefresh', response);
                    const updateParamsWithReponse = Object.assign(Object.assign({}, params), { response });
                    if (params && params.executeAfterUpdateFunc)
                        params.executeAfterUpdateFunc(updateParamsWithReponse);
                    if (vuexActionExists(state._namespace + 'executeAfterUpdateFunc')) {
                        dispatch('executeAfterUpdateFunc', updateParamsWithReponse);
                    }
                    return response;
                }
            });
        },
        processPartialRefresh({ commit, state }, payload) {
            const data = (payload === null || payload === void 0 ? void 0 : payload.data) || payload || [];
            if (!Array.isArray(data))
                return [];
            const list = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.list));
            const fullTable = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.fullTable));
            const updateList = (list, data) => {
                data.forEach(row => {
                    const idx = list.findIndex((r) => r.id && row.id && String(r.id) === String(row.id));
                    if (idx > -1) {
                        list[idx] = Object.assign(Object.assign({}, list[idx]), row); // spread-override here (instead of just list[ids] = row) is used for cases when we want to update only some fields of a record
                    }
                    else {
                        list.push(row);
                    }
                });
            };
            updateList(list, data);
            updateList(fullTable, data);
            commit('SET_LIST', list);
            commit('SET_FULL_TABLE', fullTable);
            return list;
        },
        setCurrent({ state, commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit('SET_CURRENT', id);
                localStorage.setItem(state._namespace + 'current', String(id));
                return true;
            });
        },
        setViewed({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit('SET_BEING_VIEWED', id);
                return true;
            });
        },
        delete({ getters, dispatch }, recordsToDelete) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const payload = Object.assign(Object.assign(Object.assign({}, (getters.controllerDefaultParams || {}).delete), getters.controllerDefaultParamsCommonForAllModules.delete), { action: 'delete', records: ensureArray(recordsToDelete) });
                const response = yield rpc(getters.controllers.delete, payload);
                if (response && response.result && response.result.toLowerCase() === 'success') {
                    let ids; // undefined types are added here to deal with API versions below 1
                    if (getters.apiVersion === 1) {
                        ids = (_a = payload.records) === null || _a === void 0 ? void 0 : _a.map((r) => r.id);
                    }
                    else {
                        ids = [payload.id]; // legacy way of deleting
                    }
                    dispatch('removeRecordsFromLocalState', ids);
                    return response;
                }
            });
        },
        removeRecordsFromLocalState({ commit, state }, ids) {
            var _a, _b, _c, _d, _e, _f;
            if (!ids)
                return null;
            let startingCount, endingCount, removedCount;
            if ((_a = state.pagination) === null || _a === void 0 ? void 0 : _a.count)
                startingCount = state.list.length;
            const rowsRemoved = (_b = state === null || state === void 0 ? void 0 : state.list) === null || _b === void 0 ? void 0 : _b.filter((row) => ids.map(i => String(i)).includes(String(row.id)));
            commit('SET_LIST', (_c = state === null || state === void 0 ? void 0 : state.list) === null || _c === void 0 ? void 0 : _c.filter((row) => !ids.map(i => String(i)).includes(String(row.id))));
            commit('SET_FULL_TABLE', (_d = state === null || state === void 0 ? void 0 : state.fullTable) === null || _d === void 0 ? void 0 : _d.filter((row) => !ids.map(i => String(i)).includes(String(row.id))));
            if ((_e = state.pagination) === null || _e === void 0 ? void 0 : _e.count) {
                endingCount = (_f = state === null || state === void 0 ? void 0 : state.list) === null || _f === void 0 ? void 0 : _f.length;
                removedCount = startingCount - endingCount;
                commit('SET_PAGINATION', Object.assign(Object.assign({}, state.pagination), { count: state.pagination.count - removedCount }));
            }
            return rowsRemoved;
        },
        addRecordsToLocalState({ commit, state }, rowsToAdd) {
            var _a, _b, _c, _d;
            const dataNow = state === null || state === void 0 ? void 0 : state.list;
            const idsNow = dataNow.map(r => r.id);
            const incrementalRowsToAdd = rowsToAdd.filter(r => !idsNow.includes(r.id));
            let startingCount, endingCount, removedCount;
            if ((_a = state.pagination) === null || _a === void 0 ? void 0 : _a.count)
                startingCount = (_b = state === null || state === void 0 ? void 0 : state.list) === null || _b === void 0 ? void 0 : _b.length;
            commit('SET_LIST', [...incrementalRowsToAdd, ...dataNow]);
            if ((_c = state.pagination) === null || _c === void 0 ? void 0 : _c.count) {
                endingCount = (_d = state === null || state === void 0 ? void 0 : state.list) === null || _d === void 0 ? void 0 : _d.length;
                removedCount = startingCount - endingCount;
                commit('SET_PAGINATION', Object.assign(Object.assign({}, state.pagination), { count: state.pagination.count - removedCount }));
            }
            return incrementalRowsToAdd;
        },
        updateRecordsInLocalState({ dispatch }, recordsToUpdate) {
            return dispatch('processPartialRefresh', recordsToUpdate);
        }
    };
}
